import { deDE as coreDeDE } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { deDE as dataGridDeDE } from '@mui/x-data-grid/locales';
import { deDE as datePickerDeDE } from '@mui/x-date-pickers/locales';

export const theme = createTheme(
  {
    components: {
      MuiAlert: {
        styleOverrides: {
          action: { paddingTop: '0' },
          root: {
            borderRadius: 'var(--radius-md, 4px)', // Apply Tailwind radius for consistency
          },
        },
      },
      MuiAlertTitle: { styleOverrides: { root: { fontWeight: '600' } } },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(0, 0, 0, 0.42)',
          },
        },
      },
      MuiButton: { styleOverrides: { root: { textTransform: 'none' } } },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true, // Disable MUI ripple effect for all buttons
        },
        styleOverrides: {
          root: {
            textTransform: 'none', // Remove uppercase transformation
          },
        },
      },
      MuiCardContent: {
        styleOverrides: { root: { padding: '1rem !important' } },
      },
      MuiCircularProgress: {
        styleOverrides: {
          root: {
            color: 'hsl(213, 1%, 50%)',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          '@font-face': {
            fontDisplay: 'swap',
            fontFamily: 'Inter',
          },
        },
      },
      MuiList: { styleOverrides: { root: { padding: 0 } } },
      MuiListItemIcon: { styleOverrides: { root: { minWidth: '40px' } } },
      MuiSkeleton: { defaultProps: { animation: 'wave' } },
      MuiTextField: {
        defaultProps: {
          size: 'small',
          slotProps: { inputLabel: { shrink: true } },
        },
        styleOverrides: {
          root: {
            '& .MuiInputBase-input::placeholder': {
              fontStyle: 'italic',
              paddingRight: '0.25rem',
            },
          },
        },
      },
      MuiToggleButtonGroup: {
        styleOverrides: {
          grouped: {
            '&.Mui-selected': {
              '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.13)' },
              backgroundColor: 'rgba(25, 118, 210, 0.13)',
              fontWeight: '600',
            },
            '&:not(:last-of-type)': { borderColor: '#c4c4c4' },
            borderColor: '#c4c4c4',
            textTransform: 'none',
          },
        },
      },
    },
    cssVariables: true,
    palette: {
      // primary: {
      //   main: ...,
      //   light: ...,
      //   dark: ...,
      // },
      // secondary: {
      //   main: ...,
      //   light: ...,
      //   dark: ...,
      // },
      // error: {
      //   // light: automatically calculated from main
      //   main: 'hsl(0, 80%, 56%)',
      //   // dark: automatically calculated from main
      // },
      text: { primary: 'hsl(213, 1%, 13%)' },
      warning: {
        light: 'hsl(52, 90%, 21%)',
        main: 'hsl(52, 90%, 50%)',
        // dark: ...
      },
      // info: {
      //   // light: automatically calculated from main
      // main: 'hsl(213, 54%, 74%)',
      //   // dark: automatically calculated from main
      // },
      // success: {
      //   // light: automatically calculated from main
      //   main: 'hsl(141, 71%, 48%)',
      //   // dark: automatically calculated from main
      // },
    },
    typography: {
      fontFamily: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
  },
  coreDeDE, // core translations
  dataGridDeDE, // x-data-grid translations
  datePickerDeDE, // x-date-pickers translations
);
